<template>
  <b-card>
    <b-modal 
      title="Confirmation" 
      variant="warning"
      header-bg-variant="warning"
      content-class="border-warning"
      v-model="showModal" 
      @ok="selectedAction()" 
      ok-variant="warning"
    >
      Are you sure to change the order status?
    </b-modal>

    <div slot="header" v-html="caption"></div>
    <b-table :dark="dark" selectable :hover="hover" :busy.sync="isBusy" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="captions" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template slot="id" slot-scope="data">
        S3D{{data.item.id}}
      </template>
      <template slot="manualQuoteOrder" slot-scope="data">
        <div v-if="data.item.manualQuoteOrder" class="badge badge-warning">Manual Quote</div>
        <div v-else class="badge badge-info">Instant Quote</div>
      </template>
      <template slot="status" slot-scope="data">
        <!-- <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge> -->
        <select :value="data.item.status" :disabled="['Completed','Delivered','Canceled'].includes(data.item.status) || !updatestatusAccess || (!data.item.total && data.item.manualQuote && data.item.manualQuote.Order)" @change="updatestatusAccess ? changeStatus(data.item) : ()=>{}">
          <option v-for="(status, index) in data.item.statuses" :key="index" >{{status}}</option>
        </select>
      </template>
      <template slot="createdAt" slot-scope="data">
        {{data.item.createdAt ? new Date(data.item.createdAt).toLocaleDateString() : '-'}}
      </template>
      <template slot="updatedAt" slot-scope="data">
        {{ data.item.updatedAt ? new Date(data.item.updatedAt).toLocaleDateString() : '-'}}
      </template>
      <!-- <template slot="actions" slot-scope="data">
        <b-button class="mr-1 ml-1" size="sm" variant="primary" v-on:click="!data.item.edit ? edit(data.item) : updateStatus(data.item)">{{!data.item.edit ? 'Change Status' : 'Update'}}</b-button>
        <b-button class="mr-1 ml-1" v-if="data.item.edit" size="sm" variant="danger" v-on:click="canceledit()">Cancel</b-button>
      </template> -->
      <template v-slot:row-details="row">
        <b-col xs="12" class="p-0"  style="cursor:auto">
            <b-tabs>
                <b-tab active class="p-0">
                  <template slot="title">
                      Order Details
                      <!-- <i class="icon-calculator"></i> -->
                  </template>
                  <br> 
                  <b-col xs="12">
                    <div class="d-flex flex-wrap">
                      <div class="col-4 mb-4">
                        OrderID: <b>S3D{{row.item.id}}</b>
                      </div>
                      <div class="col-4 mb-4" v-if="row.item.referer">
                        Referer OrderId: <b>S3D{{row.item.referer.id}}</b>
                      </div>
                      <div class="col-4 mb-4" v-if="row.item.quote">
                        Cart Id: <b>{{row.item.quote.cart}}</b>
                      </div>
                      <div class="col-4 mb-4">
                        Currency: <b>{{ (row.item.currency && row.item.currency.displayName) || 'INR'}}</b>
                      </div>
                      <div class="col-4 mb-4">
                        Sub Total: <b>{{row.item.subtotal}}</b>
                      </div>
                      <div class="col-4 mb-4">
                        Shipping Cost: <b>{{row.item.shippingcost || 0}}</b>
                      </div>
                      <div class="col-4 mb-4">
                        Discount: <b>{{row.item.discount}}</b>
                      </div>
                      <div class="col-4 mb-4">
                        Total: <b>{{row.item.total}}</b>
                      </div>
                      <div v-if="row.item.manualQuote && row.item.manualQuote.Order" class="col-4 mb-4">
                        Instant Order : <b>S3D{{row.item.manualQuote.Order}}</b>
                      </div>
                    </div>
                    <div class="col-12 mb-4 p-0" v-if="row.item.cartItems && row.item.cartItems.length">
                      <hr>
                      <b-col xs="12" class="p-0">
                        <b-row>
                          <b-col class="col-8">Cart Items</b-col>
                          <b-col class="col-4 text-right">
                            <router-link v-if="createQuoteAccess && editQuoteAccess && row.item.manualQuoteOrder && (!row.item.manualQuote || !row.item.manualQuote.Order)" :to="'/quotes/'+(row.item.quoteCreated ? 'edit/'+row.item.quoteCreated+'/'+row.item.id : 'create/'+row.item.id)" target="_blank">
                              <b-button class="btn-sm mx-2 text-white" variant="warning">{{row.item.quoteCreated ? 'Edit': 'Generate'}} Quote</b-button>
                            </router-link>
                            <b-button @click="downloadFile(row.item.cartItems,true)" class="btn-sm mx-2" variant="primary">Download All</b-button>
                          </b-col>
                        </b-row>
                      </b-col>
                      <br>
                      <b-col xs="12" class="p-0">
                        <b-table class="table-responsive"  :inline="true" responsive="true" :dark="true"  :hover="hover" :busy.sync="cartloading" :striped="true" :bordered="true" :small="true" :items="row.item.cartItems" :fields="cartitemFields" :current-page="currentPage" :per-page="perPage">
                          <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong> Loading...</strong>
                            </div>
                          </template>
                          <template slot="fileId" slot-scope="data">
                            {{data.item.fileId.substr(0,data.item.fileId.split('_', 2).join('_').length)}}
                          </template>
                          <template slot="mfvendor" slot-scope="data">
                            {{(data.item.mfvendordata && data.item.mfvendordata.id) ? data.item.mfvendordata.name+', '+data.item.mfvendordata.city : '-'}}
                          </template>
                          <template slot="isManualQuote" slot-scope="data">
                            <div v-if="data.item.isManualQuote" class="badge badge-warning">Manual</div>
                            <div v-else class="badge badge-info text-white">Instant</div>
                          </template>
                          <template slot="price" slot-scope="data">
                            {{data.item.price && data.item.price.subtotal}}
                          </template>
                          <template slot="actions" slot-scope="data">
                            <b-button v-if="data.item.downloadLink" @click="downloadFile([data.item])" class="btn-sm" variant="primary">Download</b-button>
                          </template>
                        </b-table>
                      <hr>
                      </b-col>
                    </div>
                    <!-- <div class="col-12 mb-4">
                      <div>Remarks</div>
                      <br>
                      <textarea class="form-control" rows="5" id="comment" style="resize: none;height:200px;"></textarea>
                    </div>
                    <hr>
                    <b-col xs="12" class="text-right">
                      <b-button class="btn-sm" variant="success">Update</b-button>
                    </b-col> -->
                  </b-col>
                </b-tab>
                <b-tab>
                  <template slot="title">
                      Customer Details
                      <!-- <i class="icon-basket-loaded"></i> -->
                  </template>
                  <br>
                  <b-col xs="12">
                    <b-row>
                      <b-col xs="12" sm="6" v-if="row.item.shippingAddress">
                        <b-card header="Shipping Details">
                          <div class="d-flex flex-wrap flex-column">
                            <span><strong>{{row.item.shippingAddress.name}}</strong></span>
                            <span> {{row.item.shippingAddress.address}}</span>
                            <span> {{row.item.shippingAddress.landmark}}</span>
                            <span> {{row.item.shippingAddress.city}} - {{row.item.shippingAddress.pincode}}, {{row.item.shippingAddress.state}}, {{row.item.shippingAddress.country}}</span>
                            <span> <b>contact:</b> {{row.item.shippingAddress.countryCode+'-'+row.item.shippingAddress.mobile}}, {{row.item.shippingAddress.email}}</span>
                          </div>
                        </b-card>
                      </b-col>
                      <b-col xs="12" sm="5" v-if="row.item.user">
                        <b-card header="User Details">
                          <div class="mb-3">
                            Name:   <b>{{row.item.user.username}}</b>
                          </div>
                          <div class="mb-3">
                            Email:   <b>{{row.item.user.email}}</b>
                          </div>
                          <div class="mb-3">
                            Mobile:   <b>{{row.item.user.mobile}}</b>
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-tab>
                <!-- <b-tab>
                  <template slot="title">
                      Order History
                      <i class="icon-pie-chart"></i>
                  </template>
                  <br>
                  <b-col xs="12">

                  </b-col>
                </b-tab> -->
            </b-tabs>
        </b-col>
      </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
    </nav>
  </b-card>
</template>

<script>
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { saveAs } from 'file-saver';

export default {
  name: 'c-table',
  inheritAttrs: false,
  props: {
    isBusy:{
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    cartitemFields:{
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 15
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      showModal:false,
      cartloading:true,
      currentPage: 1,
    }
  },
  computed: {
    items: function() {
      const items =  this.tableData
      return Array.isArray(items) ? items : items()
    },
    createQuoteAccess: function() { return this.hasAccess('createQuote')},
    editQuoteAccess: function() { return this.hasAccess('updateQuote')},
    totalRows: function () { return this.getRowCount() },
    captions: function() { return this.fields },
    updatestatusAccess: function() { return this.hasAccess('orderStatusUpdate')}
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    getRowCount: function () {
      return this.items.length
    },
    async rowClicked (item,index) {
      // Set loading
      this.cartloading=true;
      // Toggle open close accordion
      item._showDetails= !item._showDetails;
      
      if(item._showDetails){
        let Q1CartItems,Q2CartItems,currentOrderCartitems=[];
        if(item.quote && item.quote.cart){
            Q1CartItems = await this.strapi.axios.get('/carts/'+item.quote.cart);
            currentOrderCartitems=(Q1CartItems && Q1CartItems.status=='200' && Q1CartItems.data && Q1CartItems.data.cartitems) || [];
        } 
        if(item.manualQuote && item.manualQuote.cart){
            Q2CartItems = await this.strapi.axios.get('/carts/'+item.manualQuote.cart);
            currentOrderCartitems=[...currentOrderCartitems,...((Q2CartItems && Q2CartItems.status=='200' && Q2CartItems.data && Q2CartItems.data.cartitems) || [])];
        } 
        item.cartItems = currentOrderCartitems;
        this.cartloading=false;
        this.$emit('row-clicked', item)
        this.$forceUpdate();
      }
    },
    changeStatus(item){
      let newStatus = event.target.value;
      let callback = async ()=>{
        let statusdata = await this.strapi.axios.put('/orders/'+item.id,{status:newStatus});
        statusdata=(statusdata && statusdata.status=='200' && statusdata.data) || false;
        if(statusdata && statusdata.status) item.status = statusdata.status;
        this.$emit('update-orders');
        this.showModal=false;
      }
      this.selectedAction = callback;
      this.showModal=true;
    },
    selectedAction(cb){
      return cb();
    },
    downloadFile(items,zip=false){
      let links = items.map(e=>e.downloadLink);
      // Download bunch of files as zip file
      if(zip){
        let zip = new JSZip();
        let count = 0;
        let zipFilename = 'cartItems_'+(new Date().toLocaleDateString())+".zip";
  
        links.forEach(function (url, i) {
          let item = items[i];
          let fileName = item.process+'_'+item.material+'_'+item.quality+'_'+item.color+'_'+item.origName;
          // loading a file and add it in a zip file
          JSZipUtils.getBinaryContent(url, function (err, data) {
            if (err) {
              throw err; // or handle the error
            }
            zip.file(fileName, data, { binary: true });
            count++;
            if (count == links.length) {
              zip.generateAsync({ type: 'blob' }).then(function (content) {
                saveAs(content, zipFilename);
              });
            }
          });
        });
      }else{
        // Download single file
        let item = items && items[0];
        let fileName = item.process+'_'+item.material+'_'+item.quality+'_'+item.color+'_'+item.origName;
        item && saveAs(item.downloadLink,fileName );
      }
    }
  }
}
</script>
